<template>
  <div class="timeline-carousel_box" @mouseenter="pauseAutoplay"
    @mouseleave="resumeAutoplay">
    <div class="timeline-carousel">
      <!-- 时间轴线（固定） -->
      <div class="timeline-line"></div>

      <!-- Swiper 轮播 -->
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
      >
        <swiper-slide v-for="(item, index) in timelineData" :key="index">
          <div class="timeline-item" :class="{ active: currentIndex === index }">
            <!-- 节点圆点（固定在轴线上） -->
            <div class="dot-wrapper">
              <div class="dot"></div>
            </div>

            <!-- 年份文字 - 根据索引决定在轴线上方还是下方 -->
            <div class="year-text" :class="{ 
              'year-top': index % 2 === 0,     // 偶数索引：时间在轴线上
              'year-bottom': index % 2 !== 0    // 奇数索引：时间在轴线下
            }">
              {{ item.year }}
            </div>

            <!-- 内容卡片 - 与年份相反位置 -->
            <div class="content" :class="{ 
              'content-bottom': index % 2 === 0,    // 时间在上时，文字在下
              'content-top': index % 2 !== 0         // 时间在下时，文字在上
            }">
              <div class="title">{{ item.title }}</div>
              <div class="desc" v-html="item.desc"></div>
            </div>
          </div>
        </swiper-slide>

        <!-- 导航按钮 -->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'TimelineCarousel',
  props: {
    timelineData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      currentIndex: 0,
      swiperOptions: {
        speed:500,
        autoplay: {
          delay: 500,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
        slidesPerView: 5,
        spaceBetween: 0,
        centeredSlides: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    pauseAutoplay() {
      const swiper = this.$refs.mySwiper.$swiper
      if (swiper && swiper.autoplay) {
        swiper.autoplay.stop()
      }
    },
    resumeAutoplay() {
      const swiper = this.$refs.mySwiper.$swiper
      if (swiper && swiper.autoplay) {
        swiper.autoplay.start()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.mySwiper.$swiper.slideToLoop(2, 1000, false)
    })
  }
}
</script>

<style scoped>
.timeline-carousel_box {
  max-width: 1200px;
  margin: 0 auto;
}

.timeline-carousel {
  position: relative;
  padding: 100px 40px 100px;
  overflow: hidden;
}

/* 时间轴线 */
.timeline-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #37a7f6;
  border-radius: 2px;
  z-index: 1;
}

/* Swiper容器 */
.swiper-container {
  padding: 20px 0 !important;
  z-index: 3;
}

/* 时间节点 */
.timeline-item {
  position: relative;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;
  height: 350px;
}

/* 圆点容器 - 固定在轴线位置 */
.dot-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

/* 节点圆点 */
.dot {
  width: 16px;
  height: 16px;
  background: white;
  border: 3px solid #0070c0;
  border-radius: 50%;
  transition: all 0.3s;
}

/* 年份文字 */
.year-text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  font-size: 24px;
  color: #0070c0;
  padding: 4px 12px;
  z-index: 4;
  white-space: nowrap;
}

/* 为年份文字添加连接线 */
.year-text::before {
  content: '';
  position: absolute;
  left: 50%;
  width: 2px;
  height: 50px;
  background-color: #80caff;
  transform: translateX(-50%);
  z-index: -1;
}

/* 为年份文字添加端点实心点 */
.year-text::after {
  content: '';
  position: absolute;
  left: 50%;
  width: 10px;
  height: 10px;
  background-color: #80caff;
  border-radius: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

/* 年份在轴线上方 */
.year-top {
  bottom: calc(50% + 10px);
}

/* 年份在上方时的连接线 - 从轴线向下连接 */
.year-top::before {
  top: 100%;
}

/* 年份在上方时的端点 - 在文字下方 */
.year-top::after {
  top: calc(100% + 50px); /* 连接线长度40px */
}

/* 年份在轴线下方 */
.year-bottom {
  top: calc(50% + 10px);
}

/* 年份在下方时的连接线 - 从轴线向上连接 */
.year-bottom::before {
  bottom: 100%;
}

/* 年份在下方时的端点 - 在文字上方 */
.year-bottom::after {
  bottom: calc(100% + 50px); /* 连接线长度40px */
}

/* 内容卡片 */
.content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 12px;
  text-align: left;
  width: 200px;
  z-index: 2;
}

/* 卡片在上方 - 对应年份在下时 */
.content-top {
  bottom: calc(50% + 60px);
}

/* 卡片在下方 - 对应年份在上时 */
.content-bottom {
  top: calc(50% + 60px);
}

.title {
  font-size: 16px;
  line-height: 1.4;
  color: #333;
  text-align: center;
}

.desc {
  font-size: 16px;
  color: #333;
  line-height: 1.4;
  text-align: center;
}
/* 导航按钮 */
.swiper-button-prev,
.swiper-button-next {
  width: 44px;
  height: 44px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: all 0.3s;
  top: 50%;
  margin-top: 0;
  transform: translateY(-50%);
  z-index: 10;
}

.swiper-button-prev:hover,
.swiper-button-next:hover {
  background: #0070c0;
  box-shadow: 0 6px 16px rgba(0,123,255,0.3);
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
  color: #0070c0;
  transition: all 0.3s;
}

.swiper-button-prev:hover:after,
.swiper-button-next:hover:after {
  color: white;
}

.swiper-button-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>